/**
 * clickable badging experience with palette badge component
 *
 * @module views/components/ClickableBadge
 * @memberof -Common
 */
import './ClickableBadge.scss';

import React from 'react';

import classNames from 'classnames';

import Button from '@ulta/core/components/Button/Button';
import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { handleEmptyObjects } from '@ulta/core/utils/handleEmptyObjects/handleEmptyObjects';

/**
 * Represents a ClickableBadge component
 *
 * @method
 * @param { ClickableBadgeProps} props - React properties passed from composition
 * @returns ClickableBadge
 */
export const ClickableBadge = function( { item, ...props } ){
  const { imageIcon, label, itemDetailCard } = item;
  const { onClick } = handleEmptyObjects( props );

  if( !label ){
    return null;
  }

  return (
    <>
      <div
        className='ClickableBadge'
      >
        <Button
          variant='unstyled'
          onClick={ ( e ) => onClick( e ) }
          className={ classNames( 'ClickableBadge__button', {
            'ClickableBadge__Focusable': itemDetailCard
          } ) }
        >
          { imageIcon && (
            <UltaAsset { ...imageIcon }
              aspectRatio='1:1'
              width={ 32 }
              height={ 32 }
            /> ) }
          <span className='ClickableBadge__text'>
            <Text htmlTag='span'
              textStyle='label'
            >
              { label }
            </Text>
          </span>
          { itemDetailCard &&
          <Icon
            size={ 's' }
            name='caretForward'
            aria-hidden={ true }
            className='ClickableBadge__icon'
          />
          }
        </Button>
      </div>
    </>
  );
};

/**
 * Property type definitions
 * @typedef ClickableBadgeProps
 * @type {object}
 * @property {string} example - refactor or delete
 */
export const propTypes =  {
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} example='hello world' - The default refactor or delete
 */
export const defaultProps =  {
};

ClickableBadge.propTypes = propTypes;
ClickableBadge.defaultProps = defaultProps;

export default ClickableBadge;
